import { mountDateNavComponent } from './dateNav.js';
import { isZeroDate, timestampFromDate, dateFromSecondsTimestamp, createStartAndEndDatesFromArray, JPShortDateString } from './common.js'
import { isClone, isNonWorkingSlotType, isLocked, isCreatedByActiveUser } from './slot_helpers.js';
import { calcDiffCurrentAndPrevSlots } from './stats.js'
import { addRequestSlotsToSlotMap, mountShiftCalendarComponent, mountShiftViewToggleButtonComponent } from './shift_calendar.js'
import { reactive } from 'vue';
import { initSlotModalRoleListComponent, updateCurrentDate } from '../slotModal/roleList'
import timeZones from '../common/timeZones';
import { fromOplusTime, getUrlParam, jpDateString, yearMonthDateString, dateToKitchenTime } from '../common/common';
import { parseFromShiftRaw as branchSettingsParser } from '../legacy/parser/branchSettingsParser'
import { initSlotLogMap, updateSlotUnreadCommentBadge, reactiveSlotLogMap } from './slotLog.js';
import Cell from '../vue/Cell.vue';
import { createApp, computed, ref } from 'vue';
import { MeStore } from '../store/v1/meStore';
import { User } from '../model/v1/user';
import { parseSectionFromRaw } from '../parser/sectionParser';
import AskSlotModal from '../vue/components/AskSlotModal.vue';
import { RoleStore } from '../store/v1/roleStore';
import SectionEditModal from '../vue/components/SectionEditModal.vue';
import { getDateStringsForSlot, readSlots } from '../employmentShiftTable/employmentShiftTable';


// nonWorkingSlotCount is an object which tracks how many non-working (type 2, 6, 7) type slots the user used.
const nonWorkingSlotCount = {
  count: 0,
  limit: 0,
}

const CALENDAR_MOUNT_ID = {
  CALENDAR: "#shift-calendar-mount",
  TOGGLE_BUTTON: "#calendar-toggle-button",
}

const TIME_PERIOD_TYPE = Object.freeze({
  MONTHLY: "month",
  WEEKlY: "week",
  CUSTOM: "custom"
})

let lockedDateUntil = null;
let timePeriodType = "";

let branchSettings = null;
let meStore;

const sectionMap = ref({});

export const calendarReactiveObject = reactive({
  isCalendarView: isCalendarViewActive(),
  cellsMap: {},
})

export function handleInitSlotLogMap(newSlotLogMap) {
  initSlotLogMap(newSlotLogMap);
}

export function handleUpdateSlotUnreadCommentBadge(slotId, numComments = 0) {
  updateSlotUnreadCommentBadge(slotId, numComments);
}

function initMeStore(props) {
  const meStoreReq = {
    user: new User({id: props.activeUserID})
  }
  const meStoreOpt = {
    activeBranchId: props.activeCompanyID.toString(),
    isLeader: props.canEdit,
    timeZone: timeZones.ASIA_TOKYO,
  }
  return new MeStore(meStoreReq, meStoreOpt);
}

export function initPage(props) {
  meStore = initMeStore(props)
  branchSettings = branchSettingsParser(props.rawBranchSettings);
  sectionMap.value = buildSectionMap(SlotMap);

  lockedDateUntil = new Date(props.lockedDateUntil);
  timePeriodType = props.timePeriodType;
  readSlots(SlotMap, props.activeUserID);
  addRequestSlotsToSlotMap(SlotMap);
  buildShiftCellsMap(props);
  const {startDate, endDate} = createStartAndEndDatesFromArray(props.dates);
  renderTableDateColumn(props.dates);
  mountDateNavComponent("#date-nav-mount", {
    activeCompanyID: meStore.getActiveBranchId(),
    startDate: startDate,
    endDate: endDate,
    timePeriodType: props.timePeriodType,
    currentPage: props.currentPage,
    showDailyButton: true,
  });
  mountShiftViewToggleButtonComponent(CALENDAR_MOUNT_ID.TOGGLE_BUTTON, calendarReactiveObject);
  const calendarProps = {
    dates: props.dates,
    branchSettings: branchSettings,
    meStore: meStore,
  }
  mountShiftCalendarComponent(CALENDAR_MOUNT_ID.CALENDAR, calendarReactiveObject, SlotMap, calendarProps, props.roleDates, sectionMap, props.useShiftBorders)
  initSlotModalRoleListComponent(meStore.getActiveBranchId(), meStore.getActiveUserId(), true, props.roleDates);
  slot_crud.initSlotCrud(true, props.slotURL)
  // Count Off-slots if they are a Staff, Manager-level users will be defaulted to 0 limit (unlimited)
  if (!meStore.getIsLeader()) {
    initSlotUsedObj(props.monthlyVacationLimit || props.monthlyVacationLimitDefault);
  }
  toggleShiftView();

  renderVueCells(calendarReactiveObject.cellsMap, props.dates, branchSettings, SlotMap, props.useShiftBorders)

  mountAskSlotModal(props);
  mountSectionEditModal(props);
}

function renderVueCells(cellsMap, dates, branchSettings, slotMap, useShiftBorders) {
  dates.forEach(date => {
    const ds = date.String;
    const sel = `#shift-cell-mount-${ds}`;
    if (!$(sel).length) {
      return;
    }
    const props = {
      date: ds,
      userId: parseInt(meStore.getActiveUserId()),
      slotProps: cellsMap?.[ds]?.slots,
      branchSettings,
      slotMap,
      meStore,
      isStaffLocked: isLockedDateUntil(new Date(ds)),
      isUsedInShiftPage: true,
    };
    mountVueComponent(sel, props, Cell, cellsMap, useShiftBorders);
  })
}

function mountVueComponent(mountPoint, props, component, cellsMap, useShiftBorders) {
  const app = createApp(component, props);
  app.config.unwrapInjectedRef = true;
  app.provide('cellsMap', cellsMap);
  app.provide('cellEditMode', { isOn: false }); // not used in this page
  app.provide('deleteMode', { isOn: false }); // not used in this page
  app.provide('slotLogMap', computed(() => reactiveSlotLogMap));
  app.provide('useShiftBorders', useShiftBorders);
  app.provide('roleStore', new RoleStore()); // not used in this page

  window[mountPoint] = app.mount(mountPoint);
}

function renderTableDateColumn(dates) {
  dates.forEach((date) => {
    const dateText = JPShortDateString(dateFromSecondsTimestamp(date.TimeStamp), true);
    $(`.date-cell-label[data-timestamp=${date.TimeStamp}]`).text(dateText);
  })
}

function initSlotUsedObj(monthlyVacationLimit) {
  nonWorkingSlotCount.limit = monthlyVacationLimit;
  nonWorkingSlotCount.count = countOffTypeSlots();
}

function countOffTypeSlots() {
  let count = 0
  Object.keys(SlotMap).forEach(slotID => {
    const slot = SlotMap[slotID];
    if (!slot) {
      return;
    }
    if (isNonWorkingSlotType(slot) && !slot.SectionParent && !slot.IsTemplate && !slot.IsHelp && !isClone(slot, meStore.getActiveBranchId()) && !isLocked(slot) && isCreatedByActiveUser(slot, meStore.getActiveUserId())) {
      count++;
    }
  })
  return count;
}

// Getter for shift page
export function isVacationLimitMaxedOut() {
  const { count, limit } = nonWorkingSlotCount;
  return limit !== 0 && count >= limit;
}

// Setter function to update nonWorkingSlotCount object
export function calculateOffTypeSlotCount(slot, oldSlot = null) {
  // 0 means no limit
  if (nonWorkingSlotCount.limit === 0) {
    return;
  }

  const diffCount = calcDiffCurrentAndPrevSlots(slot, oldSlot);

  nonWorkingSlotCount.count += diffCount

  // Make sure the count doesn't go below 0
  nonWorkingSlotCount.count = Math.max(nonWorkingSlotCount.count, 0);
  isVacationLimitMaxedOut();
}

export function decrementOffTypeSlotCount(slot) {
  if (!isNonWorkingSlotType(slot)) {
    return;
  }

  return nonWorkingSlotCount.count--
}

export function isOffSlotBtnDisabled(slotCreatorUserID, isTemplate) {
  const commonConditions = !meStore.getIsLeader() && isVacationLimitMaxedOut() && !isTemplate;
  if (commonConditions) {
    if ((branchSettings.stackedRequest && (!slotCreatorUserID || slotCreatorUserID == meStore.getActiveUserId())) || !branchSettings.stackedRequest) {
      return true;
    }
  }
  return false;
}
// As of 2024-05-09, we don't support creating request slots on a repeat slot, this is to block staff users and enforce to create a new slot instead
export function isStaffMakingRequestSlotOnRepeat(isSlotRepeat) {
  return !meStore.getIsLeader() && branchSettings.stackedRequest && isSlotRepeat;
}

function buildShiftCellsMap(props) {
  const oplusTimeViewTo = new Date(props.dates[props.dates.length - 1].Time);

  props.dates.forEach(date => {
    const oplusDateObject = dateFromSecondsTimestamp(date.TimeStamp);
    const timestamp = oplusDateObject.valueOf();
    const dateStrKey = yearMonthDateString(fromOplusTime(oplusDateObject), timeZones.ASIA_TOKYO);
    const shiftTimeStart = addHourToTimestamp(timestamp, branchSettings.summaryDayStart);
    // End time may be over 24 hours depending on working hours
    const currentTimeEnd = branchSettings.summaryDayEnd;
    const shiftTimeEnd = addHourToTimestamp(timestamp, currentTimeEnd);
    calendarReactiveObject.cellsMap[dateStrKey] = {
      date: oplusDateObject,
      shiftTimeStart: shiftTimeStart,
      shiftTimeEnd: shiftTimeEnd,
      isLocked: isLockedDateFrom(new Date(date.Time)),
      isStaffLocked: isLockedDateUntil(new Date(date.Time)),
      isClosed: isClosed(new Date(date.Time)),
      slots: {},
    }
  })
  getSlotByDate(oplusTimeViewTo);
}

function getSlotByDate(oplusTimeViewTo) {
   Object.keys(SlotMap).forEach(slotID => {
    const slot = SlotMap[slotID];
    if (!slot) {
      return;
    }
    if (slot.IsTemplate) {
      return;
    }
    else if (slot.Repeat) {
      return addRepeatSlotsToCellsMap(slot, oplusTimeViewTo);
    }
    else {
      return addSlotToShiftCellsMap(slot);
    }
  })
}

function isLockedDateUntil(date) {
  if (!branchSettings.staffLock) {
    return false;
  }
  return !isZeroDate(lockedDateUntil) && lockedDateUntil >= date;
}

function isLockedDateFrom(date) {
  let out = false;
  if (branchSettings.shiftLockDate && !isZeroDate(new Date(branchSettings.shiftLockDate))) {
    const shiftLockDate = new Date(branchSettings.shiftLockDate);

    out = shiftLockDate <= new Date(date);
  }
  return out;
}

function isClosed(date) {
  return branchSettings.closedWeekdays?.[date.getUTCDay()];
}

function addRepeatSlotsToCellsMap(slot, viewTo) {
  const repeatUntil = new Date(slot.RepeatUntil);
  viewTo.setUTCHours(23, 59, 59, 999);
  const curFrom = new Date(slot.From);
  curFrom.setUTCHours(curFrom.getUTCHours(), curFrom.getUTCMinutes(), curFrom.getUTCSeconds(), curFrom.getUTCMilliseconds());
  const repeatExcludeMap = {};

  slot.RepeatExclude?.forEach(d => {
    repeatExcludeMap[timestampFromDate(d)] = true;
  });

  do {
    const d = timestampFromDate(curFrom);
    if (!repeatExcludeMap[d]) {
      // if not locked only, just add
      addSlotToShiftCellsMap(slot, d);
    }
    curFrom.setUTCDate(curFrom.getUTCDate() + 7)
  } while (curFrom <= viewTo && curFrom <= repeatUntil)
}


function addSlotToShiftCellsMap(slot, repeatDate) {
  if (slot.ManagedSlotKey) {
    return;
  }
  const repDate = repeatDate ? new Date(repeatDate) : null;
  const dateStrKeys = getDateStringsForSlot(slot, meStore.getTimeZone(), repDate);

  if (!branchSettings.splitNightShift && dateStrKeys.length > 1) {
    dateStrKeys.pop();
  }
  dateStrKeys.forEach(dateStr => {
    if (!calendarReactiveObject.cellsMap[dateStr]) {
      calendarReactiveObject.cellsMap[dateStr] = { slots: {} }
    }


    calendarReactiveObject.cellsMap[dateStr].slots[slot.ID] = {
      sections: {}
    };

    if (slot.SectionSlots) {
      slot.SectionSlots.forEach(s => {
        calendarReactiveObject.cellsMap[dateStr].slots[slot.ID].sections[s.ID] = {}
      })
    }
  })
}

function renderSlotInShiftTable(cellDateStr) {
  const cellApp = window[`#shift-cell-mount-${cellDateStr}`];
  if (!cellApp) {
    return;
  }
  cellApp.updateSlots(calendarReactiveObject.cellsMap[cellDateStr].slots);
}

export function addAndRenderSlotInTable(slot, oldSlot = null) {
  const dateStrKeys = getDateStringsForSlot(slot, meStore.getTimeZone());
  let oldDateStrKeys = [];

  if (oldSlot) {
    removeSlotFromShiftCellsMap(oldSlot)
    oldDateStrKeys = getDateStringsForSlot(oldSlot, meStore.getTimeZone());
  }
  const allKeys = [...new Set([...dateStrKeys, ...oldDateStrKeys])] // remove dups
  addSlotToShiftCellsMap(slot);
  allKeys.forEach(dateStr => {
    renderSlotInShiftTable(dateStr)
  })
}


export function removeSlotFromShiftCellsMap(slot) {
  const dateStrKeys = getDateStringsForSlot(slot, meStore.getTimeZone())
  dateStrKeys.forEach(dateStr => {
    delete calendarReactiveObject.cellsMap[dateStr].slots[slot.ID];
  })
}

export function removeSlotAndRerender(slot) {
  const dateStr = getDateStringsForSlot(slot, meStore.getTimeZone());
  dateStr.forEach(dStr => {
    removeSlotFromShiftCellsMap(slot);
    renderSlotInShiftTable(dStr);
  })
}

// Shift table slot render function ** END **

export function makeDateFromDateUnix(dateUnix) {
  const date = dateFromSecondsTimestamp(dateUnix);

  return yearMonthDateString(date);
}

export function makeDateLabel(dateUnix) {
  const date = dateFromSecondsTimestamp(dateUnix);

  return jpDateString(date, meStore.getTimeZone(), true)
}

function toggleShiftView() {
  if (isDailyView()) {
    calendarReactiveObject.isCalendarView = true;
  }
  if (calendarReactiveObject.isCalendarView) {
    $("#shift-list").addClass("d-none");
    $("#shift-calendar-mount").removeClass("hidden");
  } else {
    calendarReactiveObject.isCalendarView = false;
    $("#shift-list").removeClass("d-none");
    // this is to make the mounted component's height become 0
    // we can't use display: none here since table and calendar shares a common data, which is need for reactivity in vue
    $("#shift-calendar-mount").addClass("hidden");
  }
}

export function isMonthlyView() {
  return timePeriodType === TIME_PERIOD_TYPE.MONTHLY;
}

export function isWeeklyView() {
  return timePeriodType === TIME_PERIOD_TYPE.WEEKlY;
}

export function isDailyView() {
  // Note: we use custom list with the same start and end dates, this is to make it date object consistent with monthly and weekly
  return timePeriodType === TIME_PERIOD_TYPE.CUSTOM;
}

export function setShiftViewLocalStorage() {
  if (calendarReactiveObject.isCalendarView) {
    window.localStorage.removeItem("isShiftTableActive");
  } else {
    window.localStorage.setItem("isShiftTableActive", true);
  }
  toggleShiftView();
}

function isCalendarViewActive() {
  return window.localStorage.getItem("isShiftTableActive") === null;
}

function convertHourDurationToMilliseconds(hour) {
  return hour * 3600000
}

function addHourToTimestamp(ts, hour) {
  return convertHourDurationToMilliseconds(hour) + ts;
}

export function filterSlotsForCalendarCell(cellSlots, isCellDisabled, slotMap) {
  const slotIds = Object.keys(cellSlots);
  const isStackSlotModeOn = branchSettings.stackedRequest;
  const canEdit = meStore.getIsLeader();
  const userID = meStore.getActiveUserId();
  if (!canEdit && isCellDisabled) {
    // Staff-level permission filtering
    // If stackSlots settings is off and cell is locked, staff will not be shown any slots (even the one they created);
    if (!isStackSlotModeOn) {
      return [];
    }
    // Otherwise just show the one they created
    return slotIds.filter(slotId => {
      const slot = slotMap?.[slotId];
      // Slots with ManagedSlotKey indicates they are Requested slots (slot created by non-manager level)
      if (!slot || slot?.ManagedSlotKey) {
        return false
      }

      // Remove declined slots from staff view
      if (slot.AskStatus === 3) {
        return false;
      }

      // Slots with RequestedSlotKey are slots that is created by manager in response to staff's slot (Requested by Manager)
      if (slot.RequestedSlotKey && slot.RequestedSlotID !== null || isCreatedByActiveUser(slot, userID)) {
        return true
      }

      return false;
    }).map(slotId => {
      const slot = slotMap?.[slotId];
      return slot.RequestedSlotKey ? slot.RequestedSlotID : slotId;
    });
  }

  // General case for editable accounts, (don't include requested slots)
  return slotIds.filter(slotId => {
    const slot = slotMap?.[slotId];
    // Remove declined slots from staff view
    if (!slot || (!canEdit && slot.AskStatus === 3)) {
      return false;
    }
    return !slot.ManagedSlotKey;
  });
}

export function openAskSlotModal(dateUnix, slotId, messageDate, messageName) {
  window["#ask-slot-modal"].openModal(dateUnix, slotId, messageDate, messageName);
}

function mountAskSlotModal(props) {
  const app = createApp(AskSlotModal, {
    userId: props.activeUserID,
    branchId: props.activeCompanyID,
  })
  window["#ask-slot-modal"] = app.mount("#ask-slot-modal");
}

export function setSlotAskStatus(slotID, status) {
  const slot = SlotMap[slotID];
  if (!slot) {
    return;
  }
  slot.AskStatus = status;
}

export function slotModalOnSubmit(slotId, isNew) {
  const slot = SlotMap[slotId];
  if (!slot) {
    return;
  }
  SlotModal.onSubmit(slot, isNew);
}

export function handleOpenShiftSlotModal(dateUnix, slotID, isEdit = false) {
  openShiftSlotModal(dateUnix, slotID, isEdit);
}

export function openAlertModal(errText) {
  return alertModal.alert(errText)
}

export const updateRoleListDate = updateCurrentDate;

function buildSectionMap(slotMap) {
  const map = {};
  Object.values(slotMap).forEach(slot => {
    if (!slot?.SectionSlots) {
      return;
    }
    slot.SectionSlots.forEach(section => {
      map[section.ID] = section;
    })
  })

  return map;
}

export function updateSectionMap(updatedSection) {
  if (!updatedSection?.ID) {
    return;
  }

  Object.assign(sectionMap.value[updatedSection.ID], updatedSection);
}

function mountSectionEditModal(props) {
  const app = createApp(SectionEditModal, {
    userId: props.activeUserID,
    branchId: props.activeCompanyID,
    canEdit: meStore.getIsLeader() || false,
  })
  window["#section-edit-modal"] = app.mount("#section-edit-modal");
}

export function openSectionEditModal(section, isRepeatSlot) {
  const sectionData = parseSectionFromRaw(section);
  window["#section-edit-modal"].openModal(sectionData, Boolean(isRepeatSlot));
}
